import { apiRequest } from "@/lib/api";
import type { AuthUser } from "@/lib/auth-store";

export interface TokenResponse {
  access_token: string;
  refresh_token: string;
  token_type: string;
  expires_in: number;
}

export async function login(
  email: string,
  password: string,
  code?: string,
): Promise<TokenResponse> {
  const form = new URLSearchParams();
  form.set("username", email);
  form.set("password", password);
  if (code && code.trim()) form.set("code", code.trim());
  return apiRequest<TokenResponse>("/auth/login", {
    method: "POST",
    form,
    skipAuth: true,
  });
}

export async function getMe(): Promise<AuthUser> {
  return apiRequest<AuthUser>("/auth/me", { method: "GET" });
}

// ─────────────────────── 2FA TOTP ───────────────────────

export interface TotpStatus {
  enrolled: boolean;
  enabled: boolean;
}

export interface TotpEnrollResponse {
  secret: string;
  provisioning_uri: string;
  qr_svg: string;
}

export const totpApi = {
  status: () => apiRequest<TotpStatus>("/auth/2fa/status", { method: "GET" }),
  enroll: () => apiRequest<TotpEnrollResponse>("/auth/2fa/enroll", { method: "POST" }),
  verifyEnroll: (code: string) =>
    apiRequest<TotpStatus>("/auth/2fa/verify-enroll", {
      method: "POST",
      body: { code },
    }),
  disable: (code: string) =>
    apiRequest<TotpStatus>("/auth/2fa/disable", {
      method: "POST",
      body: { code },
    }),
};
